import favicon from './favicon.webp';
import logo from './Logo.jpg';
import search_icon from './search-icon.svg';
import header_img from  './header-img.jpeg';
import BinBuddy_Process from './BinBuddy_Process.png';

export const assets = {
  favicon,
  logo,
  search_icon,
  header_img,
  BinBuddy_Process,
};